var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oauth-popup-result"},[_c('p',[_vm._v(_vm._s(_vm.$t('Connection completed. You can close this window.')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }